const SectionInstructions = ({ children }) => (
  <div className="w-full text-lightGray-1 text-sm mb-8">{children}</div>
);

export default SectionInstructions;
